module.exports = __webpack_public_path__ + "media/images/img-travel-6-cd436d66.jpg";